/** The views of the Browse Catalogue / Create Your Registry flow. */
export const REGISTRY_SETUP_STAGES = {
	CHOOSE: "choose",
	STARTER: "starter",
	CATALOGUE: "catalogue",
	SUCCESS: "success",
};
